module.exports = __webpack_public_path__ + "static/media/mediMaps.a9e55797.svg";